module.exports = __webpack_public_path__ + "img/loading.0d0345f6.gif";